import { makeStyles } from '@material-ui/core';
import theme, { fonts } from '../../../theme';

export const useStyles = makeStyles({
  // Common
  form: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    paddingBottom: '2.5em',
  },
  fieldLine: {
    marginTop: 8,

    '& > div': {
      minWidth: 470,
    },
    '& span': {
      fontSize: 18,
      marginBottom: 5,
    },
  },
  fieldLineEmail: {
    paddingTop: 176,

    '& > div': {
      minWidth: 470,
    },
    '& span': {
      fontSize: 18,
      marginBottom: 5,
    },
  },

  // Step1: RGPD Reminder
  boxReminder: {
    marginTop: '80px',
    width: '50%',
    textAlign: 'left',
    fontFamily: fonts.secondary,

    '& p': {
      marginBottom: '30px',
    },
  },
  downloadLink: {
    textDecoration: 'none',
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: '1rem',
    fontWeight: 400,
    padding: '0px 0px',
  },

  // Step4: SortingCenterChoices
  fieldHeader: {
    textAlign: 'left',
    marginTop: 8,
    marginBottom: 16,
    paddingLeft: '20px',

    '& > p': {
      minWidth: 490,
    },
  },
  listItemContainer: {
    '& li': {
      padding: 0,
    },
    '& li div': {
      padding: '0px',
      margin: '0px',
    },
    '& li > div:first-child': {
      height: '54px',
      borderRight: '2px solid #EDEDED',
      paddingLeft: '12px',
    },
    '& span': {
      paddingLeft: '12px',
      paddingRight: '12px',
      fontSize: 18,
      marginBottom: 5,
    },
  },
  divScroll: {
    overflow: 'auto',
    maxHeight: '490px',
    width: '490px',
  },
  treeBottom: {
    width: '490px',
    borderBottom: '2px solid #EDEDED',
  },
  itemLabel: {
    paddingLeft: '20px',
  },
  primary: {
    paddingLeft: '0px !important',
    color: theme.palette.primary.main,
  },
  sortingCentersSuccess: {
    align: 'left',
  },
  sortingCentersErrors: {
    align: 'left',
    color: '#FF0000',
  },

  // Step5: sortingCenterUserRoleChoices
  divScrollRole: {
    width: '60%',
    overflow: 'auto',
    maxHeight: '450px',
  },
});
